import { render } from "./cert.vue?vue&type=template&id=4d3b4246&scoped=true"
import script from "./cert.vue?vue&type=script&lang=js"
export * from "./cert.vue?vue&type=script&lang=js"

import "./cert.vue?vue&type=style&index=0&id=4d3b4246&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3b4246"]])

export default __exports__